import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import "../../assets/css/Newsletter.css";
import "../../assets/css/style.css";
import "../../assets/css/header.css";
import parse from "html-react-parser";
import {getNewsletterByNumero} from '../../services/NewsletterService';
import LoadingPage from '../../../admin/pages/inc/LoadingPage';
import HeaderNewWebsite from "../header/HeaderNewWebsite";
import defaultLang from "../../config";

const Newsletter = () => {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [content, setContent] = useState(""); // <- contenu transformé
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNewsletters = async () => {
      setLoading(true);
      try {
        const lang = JSON.parse(localStorage.getItem("lang")) || defaultLang;
        const data = await getNewsletterByNumero(id, lang.idlanguage);
        if (!data) {
          navigate('/');
        }
        setNews(data);
        
        // Remplacement des <br> sur mobile
        const handleTransform = () => {
          if (window.innerWidth <= 768) {
            // remplace <br> et variantes <br/> <br /> par espace
            const mobileContent = data.content.replace(/<br\s*\/?>/gi, " ");
            setContent(mobileContent);
          } else {
            setContent(data.content);
          }
        };

        handleTransform(); // exécute au chargement
        window.addEventListener("resize", handleTransform);
        return () => window.removeEventListener("resize", handleTransform);
      } catch (err) {
        setError(err.message || "Erreur lors du chargement");
      } finally {
        setLoading(false);
      }
    };

    fetchNewsletters();
  }, [id]);

  if (loading) return <LoadingPage />;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <>
      <header forceBackground={true}>
        {/* <HeaderNavigation /> */}
        <HeaderNewWebsite />
      </header>

      <div className="details-newsletter">
        <div className="row position-relative">
          <div className="col-sm-12 col-md- col-xl-12">
            <img
              src={news.cover}
              alt="background"
              className="background-image"
            />
          </div>

          <div className="ID-box">
            <div style={{ display: "inline-flex", alignItems: "center" }} className="ID">
              <span className="Newsletter-label">
                NEWSLETTER
                <div className="pattern-box"></div>
                <span
                  className="linkdin-icon"
                  style={{
                    fontSize: "30px",
                    verticalAlign: "super",
                    marginLeft: "1px",
                    position: "relative",
                    top: "30px",
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 36 36">
                    <g id="linkedin-icon-3" transform="translate(0 -5)">
                      <path id="Path_3735" data-name="Path 3735" d="M185.2,313.1h29.882v28.6H185.2Z" transform="translate(-182.522 -303.646)" fill="#fff" />
                      <path id="Path_3736" data-name="Path 3736" d="M0,7.579A2.621,2.621,0,0,1,2.66,5H33.34A2.621,2.621,0,0,1,36,7.579V38.422A2.62,2.62,0,0,1,33.34,41H2.66A2.62,2.62,0,0,1,0,38.422Z" fill="#0a66c2" />
                      <path id="Path_3737" data-name="Path 3737" d="M367.9,451.42V435.213h-5.387V451.42ZM365.212,433a3,3,0,1,0-.035,0Zm5.673,18.419h5.387V442.37a3.669,3.669,0,0,1,.178-1.314,2.947,2.947,0,0,1,2.764-1.971c1.949,0,2.728,1.486,2.728,3.665v8.669h5.387v-9.292c0-4.978-2.657-7.294-6.2-7.294a5.368,5.368,0,0,0-4.891,2.73h.036v-2.349h-5.388C370.956,436.734,370.885,451.42,370.885,451.42Z" transform="translate(-356.963 -416.293)" fill="#fff" />
                    </g>
                  </svg>
                </span>
              </span>
              <span className="Newsletter-ID">#{news.numero}</span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="newsletter-content">
            {parse(content)} {/* contenu transformé ici */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Newsletter;
